/**
 * Ссылка на главную с промокодом и UTM для рассылок / рекламы.
 * Пример: https://idealitika.ru/?promo=DEMO-REPORT&utm_source=tg&utm_medium=social&utm_campaign=demo
 */

import { getAppUrl } from "@/lib/app-url";

export const PROMO_QUERY_KEY = "promo";

export type PromoUtmFields = {
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmContent?: string | null;
  utmTerm?: string | null;
};

export type PromoLinkInput = {
  code: string;
  channel?: string | null;
  subchannel?: string | null;
  campaign?: string | null;
  isDemo?: boolean;
  /** Override base origin (для превью в админке). */
  baseUrl?: string;
} & PromoUtmFields;

function slugUtm(value: string | null | undefined, fallback = ""): string {
  const raw = (value ?? "").trim().toLowerCase();
  if (!raw) return fallback;
  return (
    raw
      .replace(/[^a-z0-9_-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .slice(0, 64) || fallback
  );
}

/** Дефолты UTM из канала промокода (можно переопределить вручную). */
export function defaultPromoUtm(input: {
  code: string;
  channel?: string | null;
  subchannel?: string | null;
  campaign?: string | null;
  isDemo?: boolean;
}): Required<PromoUtmFields> {
  const code = input.code.trim().toUpperCase();
  return {
    utmSource: slugUtm(input.channel, input.isDemo ? "demo" : "coupon"),
    utmMedium: slugUtm(
      input.subchannel,
      input.isDemo ? "demo_link" : "coupon",
    ),
    utmCampaign: slugUtm(input.campaign, input.isDemo ? "demo" : "coupon"),
    utmContent: code ? code.toLowerCase() : "",
    utmTerm: "",
  };
}

export function buildPromoShareUrl(input: PromoLinkInput): string {
  const base = (input.baseUrl ?? getAppUrl()).replace(/\/$/, "");
  const code = input.code.trim().toUpperCase();
  const defaults = defaultPromoUtm(input);
  const params = new URLSearchParams();
  params.set(PROMO_QUERY_KEY, code);

  const source = slugUtm(input.utmSource, defaults.utmSource ?? "");
  const medium = slugUtm(input.utmMedium, defaults.utmMedium ?? "");
  const campaign = slugUtm(input.utmCampaign, defaults.utmCampaign ?? "");
  const content = slugUtm(input.utmContent, defaults.utmContent ?? "");
  const term = slugUtm(input.utmTerm, "");

  if (source) params.set("utm_source", source);
  if (medium) params.set("utm_medium", medium);
  if (campaign) params.set("utm_campaign", campaign);
  if (content) params.set("utm_content", content);
  if (term) params.set("utm_term", term);

  return `${base}/?${params.toString()}`;
}
